export const messages = {
  en: {
    wuyeRegister: {
      selectProvince: 'Select Province',
      selectCity: 'Select City',
      selectDistrict: 'Select District',
      shopNamePlaceholder: 'Please enter shop name',
      selectShopType: 'Please select shop type',
      passwordPlaceholder: 'Please enter password',
      register: 'Register',
      shopNameRequired: 'Shop name cannot be empty',
      passwordRequired: 'Password cannot be empty',
      areaRequired: 'Area cannot be empty',
      areaLoadFailed: 'Failed to load area data',
      shopTypeLoadFailed: 'Failed to load shop types',
      noShopWarning: 'The merchant has no shops, please contact the operation team'
    }
  },
  zh: {
    wuyeRegister: {
      selectProvince: '请选择省',
      selectCity: '请选择城市',
      selectDistrict: '请选择区县',
      shopNamePlaceholder: '请输入商铺名称',
      selectShopType: '请选择商铺类型',
      passwordPlaceholder: '请输入密码',
      register: '注册',
      shopNameRequired: '商铺名不能为空',
      passwordRequired: '密码不能为空',
      areaRequired: '地区不能为空',
      areaLoadFailed: '查询地区失败',
      shopTypeLoadFailed: '获取商铺类型失败',
      noShopWarning: '商家不存在店铺，请联系运营团队'
    }
  }
}